// extracted by mini-css-extract-plugin
export default {"block":"ingredient-block_block__M4a5p","container":"ingredient-block_container__jjwnW"};